module.exports = "<!-- Wrapper-->\n<div id=\"wrapper\">\n\n  <!-- Main page wrapper -->\n  <div id=\"page-wrapper\" class=\"gray-bg\">\n\n    <!-- Top navigation -->\n    <topnavigationnavbar></topnavigationnavbar>\n\n    <!-- Main view/routes wrapper-->\n    <router-outlet></router-outlet>\n\n    <!-- Footer -->\n    <footer></footer>\n\n  </div>\n  <!-- End page wrapper-->\n\n</div>\n<!-- End wrapper-->\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/common/layouts/topNavigationLayout.template.html
// module id = ./src/app/components/common/layouts/topNavigationLayout.template.html
// module chunks = main